import { createFileRoute } from "@tanstack/react-router";
import { PatientsPage } from "@/components/patients/patients-page";

export const Route = createFileRoute("/_app/patients")({
  component: PatientsPage,
});
